/** @format */

export const END_POINT = {
  AUTH: {
    LOGIN: "/api/admins/login",

    REGISTER: "/api/v1/auth/sign-up",
    REFRESH_TOKEN: "/auth/refresh-token",
    CHANGE_PASSWORD: "/auth/change-password",
    LOGIN_SOCIAL: "/auth/login-social",
    VERIFY_OTP: "/api/v1/verification/",
    VERIFY_EMAIL: "/api/v1/auth/email-verification",
  },
  USER: {
    GET_PROFILE: "/api/v1/user/profile",
    LOGOUT: "/user/logout",
    UPDATE_PROFILE: "/user/profile",
    UPDATE_PASS: "/auth/update-password",
    GET_BLOB_IMG: "storage/download-link",
    NOTIFICATION: "/notifications",
  },
  PRODUCT: {
    GET_PRODUCTS: "/api/products",
    DETELE_PRODUCTS: "/api/products/admin/delete",
    UPDATE_PRODUCTS: "/api/products/admin/update",
    CREATE_PRODUCTS: "/api/products/admin/create",
  },
  BRANDS: {
    GET_BRANDS: "/api/brands",
    DETELE_BRANDS: "/api/brands/admin/delete",
    UPDATE_BRANDS: "/api/brands/admin/update",
    CREATE_BRANDS: "/api/brands/admin/create",
  },
  CATEGORY: {
    GET_CATEGORY: "/api/category",
    DETELE_CATEGORY: "/api/category/admin/delete",
    UPDATE_CATEGORY: "/api/category/admin/update",
    CREATE_CATEGORY: "/api/category/admin/create",
  },
  SUPPLIER: {
    GET_SUPPLIER: "/api/supplier",
    DETELE_SUPPLIER: "/api/supplier/admin/delete",
    UPDATE_SUPPLIER: "/api/supplier/admin/update",
    CREATE_SUPPLIER: "/api/supplier/admin/create",
  },
  MASTER_DATA: {
    GET_MASTER_DATA: "/api/master-data",
    DETELE_MASTER_DATA: "/api/master-data/admin/delete",
    UPDATE_MASTER_DATA: "/api/master-data/admin/update",
    CREATE_MASTER_DATA: "/api/master-data/admin/create",
  },
  OTP: {
    SEND_OTP: "/send-mail/otp",
  },
};
